import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box, TextField, Typography } from "@mui/material";
import { useAppStore } from "../../appStore";
import dayjs from "dayjs";

export default function CustomizedDatePickerForHistory() {
  const { setSelectedDateHistory } = useAppStore();
  const [selectedDate, setSelectedDate] = React.useState(dayjs()); // Default to today's date

  // Function to format the date as 'YYYY-MM-DD'
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
    return formattedDate;
  };

  // On first mount — set default (today's) date into store
  React.useEffect(() => {
    const todayFormatted = formatDate(new Date());
    setSelectedDateHistory(todayFormatted);
    console.log("Default date set in store:", todayFormatted);
  }, []);

  // When user changes date
  const handleDateChange = (date) => {
    const formattedDate = formatDate(date);
    setSelectedDate(dayjs(date));
    setSelectedDateHistory(formattedDate);
    console.log("User-selected date set in store:", formattedDate);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: { xs: "100%", sm: "auto" },
        mb: 2,
      }}
    >
      <Typography
        sx={{
          mr: 1,
          display: { xs: "none", sm: "contents" },
          whiteSpace: "nowrap",
        }}
      >
        Choose Date:
      </Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box sx={{ width: "100%" }}>
          <DemoContainer components={["DatePicker"]}>
            <DatePicker
              value={selectedDate}
              onChange={handleDateChange}
              renderInput={(params) => <TextField {...params} sx={{ p: 0 }} />}
              format="DD/MM/YYYY"
            />
          </DemoContainer>
        </Box>
      </LocalizationProvider>
    </Box>
  );
}
